import React, { useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useTheme } from '../context/ThemeContext';
import {
  TableCellsIcon, QrCodeIcon, FireIcon
} from '@heroicons/react/24/outline';
import '../styles/comprehensive-responsive-system.css';

const StewardBottomNavigation: React.FC = () => {
  const location = useLocation();
  const { theme } = useTheme();

  // Adding a class to the body to add padding at the bottom
  useEffect(() => {
    document.body.classList.add('has-bottom-nav');
    return () => {
      document.body.classList.remove('has-bottom-nav');
    };
  }, []);

  const navItems = [
    {
      path: '/steward/tables',
      label: 'Tables',
      icon: TableCellsIcon,
    },
    {
      path: '/vendor/kitchen',
      label: 'Kitchen',
      icon: FireIcon,
    },
    {
      path: '/steward/scanner',
      label: 'Scan',
      icon: QrCodeIcon,
    }
  ];

  return (
    <div
      className="fixed bottom-0 left-0 w-full z-[1002] flex justify-around items-center lg:hidden h-16 vendor-bottom-nav"
      style={{
        backgroundColor: theme.background,
        fontFamily: 'var(--font-family-base)'
      }}
    >
      {navItems.map((item) => {
        const isActive = item.path === '/steward/tables'
          ? location.pathname.startsWith('/steward/tables')
          : location.pathname === item.path;
        const Icon = item.icon;

        return (
          <Link
            key={item.path}
            to={item.path}
            className="flex flex-col items-center justify-center transition-all duration-200 rounded-lg relative group py-responsive-sm px-responsive-sm touch-target"
            style={{
              fontSize: '0.75rem',
              color: isActive ? theme.primary : theme.gray?.[600] || '#666666',
              fontWeight: isActive ? '600' : '400',
              backgroundColor: isActive ? theme.button.secondary.bg : 'transparent'
            }}
            onMouseEnter={(e) => {
              if (!isActive) {
                e.currentTarget.style.backgroundColor = theme.components?.card?.hover || '#f5f5f5';
              }
            }}
            onMouseLeave={(e) => {
              if (!isActive) {
                e.currentTarget.style.backgroundColor = 'transparent';
              }
            }}
          >
            <Icon className={`w-6 h-6 mb-1 transition-transform duration-200 ${isActive ? 'scale-110' : 'group-hover:scale-105'}`} />
            <span className="tracking-wide">{item.label}</span>
            {isActive && (
              <div
                className="absolute left-2 right-2 h-[2px] rounded-full"
                style={{ bottom: '-3px', backgroundColor: theme.primary }}
              />
            )}
          </Link>
        );
      })}
    </div>
  );
};

export default StewardBottomNavigation;
